import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class LeasecommitmentserviceService {

  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  apiUrl = this.ConfigService.getAPIBaseUrl() + 'api/Operatingleasecommitments/';

  insertlease(data:any) {
    debugger
    return this.http.post(this.apiUrl + 'Adding', data)
  }

  getleasecommit(id) {
    debugger
    return this.http.get(this.apiUrl + 'GetOne?id='+id)
  }
  getleasecommitLY(id) {
    debugger
    return this.http.get(this.apiUrl + 'GetOne?id=' + id)
  }
}
